<script lang="ts">
  import ReviewCard from 'src/components/ReviewCard.svelte';
  import type { BusinessReviewEntry } from 'src/function-utils/data-models';
  import { BusinessReviewEntryType } from 'src/function-utils/data-models';

  export let businessKey: string;
  export let review: BusinessReviewEntry;
  export let isCelebrity: boolean = false;

  $: isVideo = [
    BusinessReviewEntryType.RAVELY_VIDEO,
    BusinessReviewEntryType.YOUTUBE_VIDEO,
  ].includes(review.type);
</script>

<div
  class="card rounded-borders {$$restProps.class || ''} {isVideo
    ? ''
    : 'pa-md border-1'}"
>
  <ReviewCard
    user={review.authorEmbedded}
    reviewType={review.type}
    message={review.message}
    date={review.ts}
    reviewOriginUrl={review.reviewOriginUrl}
    recommended={review.recommended}
    rating={review.rating}
    ratingMax={review.ratingMax}
    {isCelebrity}
    disableTruncate
    {businessKey}
  />
</div>

<style lang="scss">
  .card {
    background: white;
    overflow: hidden;
  }
</style>
